import { MatSort, MatSortable } from '@angular/material/sort';
import { User } from './../../master-visualizar-perfil.model';
import { Component, Input, OnInit, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-master-visualizar-perfil-usuarios',
  templateUrl: './master-visualizar-perfil-usuarios.component.html',
  styleUrls: ['./master-visualizar-perfil-usuarios.component.scss'],
})
export class MasterVisualizarPerfilUsuariosComponent
  implements OnInit, OnChanges {
  @Input() set users(users: User[]) {
    this.usersDS = new MatTableDataSource<User>(
      users.naturalSort(['userName']),
    );

    this.usersDS.sortingDataAccessor = (data, header) =>
      data[header].naturalNormalize();
  }

  usersDS: MatTableDataSource<User>;

  usersFilter: any;

  usersComplete: any;

  @ViewChild('sortUsers', { static: true }) sortUsers: MatSort;

  columns = ['userName', 'login', 'profile', 'status'];

  constructor() { }

  ngOnInit() {
    this.sortUsers.sort({ id: 'userName', start: 'asc' } as MatSortable);
    this.sortUsers.disableClear = true;
  }

  ngOnChanges() {
    this.usersDS.sortingDataAccessor = (data, sortHeader) =>
      data[sortHeader].naturalNormalize();
    this.usersDS.sort = this.sortUsers;
  }

  filterUsers(event?: Event) {
    this.usersDS.filterPredicate = (data, filter) => {
      return data.userName.toLowerCase().includes(filter.toLowerCase());
    };
    this.usersFilter = (event.target as HTMLInputElement).value;
    this.usersDS.filter = this.usersFilter;

    if (this.usersFilter.length > 0 && this.usersFilter.length % 2 == 0) {
      this.usersComplete = this.usersDS.filteredData;
    } else if (this.usersFilter.length == 0) {
      this.usersComplete = [];
    }
  }

  editProfile() { }
}
